module.exports = __webpack_public_path__ + "img/programme1.ae31f88f.png";